module.exports = {
      id: "tag-usage",
      viewBox: "0 0 30.383 24.21",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#tag",
      toString: function () {
        return this.url;
      }
    }